// extracted by mini-css-extract-plugin
export default {"form":"form__OPgBwa5l","label":"label__rSLHch7N","input":"input__Kec8HfBc","button":"button__kn8Qz_Vx","body":"body__L_A1kzrt","textInput":"textInput__zvcFZEeh"};